import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { Camera } from "@awesome-cordova-plugins/camera/ngx"
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@ionic-native/file/ngx';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ComponentsModule } from './components/components.module';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({

  imports: [BrowserModule, 

FontAwesomeModule,
    FormsModule,IonicModule,IonicSelectableModule
    ,ComponentsModule,NgxSummernoteModule, IonicModule.forRoot(), AppRoutingModule,HttpClientModule, ],
  providers: 
  [CallNumber, 
  Camera,
  FileOpener,
 
  AndroidPermissions,

  File,
  HTTP,
  { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],

  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule {
 constructor(library: FaIconLibrary) { 
		library.addIconPacks(fas, fab, far);
	}
}
